/**
 * Appointment Utilities JavaScript
 * Utility functions for date/time formatting and other helpers
 */

// Date/Time formatting functions
function formatDate(dateStr) {
    if (!dateStr) return "";

    let date;

    // If the string is a simple YYYY-MM-DD (no timezone information), construct
    // the Date in local time to avoid the UTC → local offset that causes the
    // displayed day to shift backwards in some timezones.
    if (isValidDateFormat(dateStr)) {
        const [year, month, day] = dateStr.split("-").map(Number);
        // JS Date months are 0-indexed
        date = new Date(year, month - 1, day);
    } else {
        // Fallback to native parsing (includes timezone information)
        date = new Date(dateStr);
    }

    const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

    const weekday = capitalize(date.toLocaleString('en', { weekday: 'long' }));
    const monthName = capitalize(date.toLocaleString('en', { month: 'long' }));
    const dayNum = date.getDate();
    return `${weekday} ${monthName} ${dayNum}`;
}

function formatTime(dateStr) {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    if (hours === 0) hours = 12;
    return `${hours}:${minutes} ${ampm}`;
}

// Skeleton loading generator
function generateSkeletonLoading() {
    const skeletonItems = Array.from({ length: 7 }, (_, index) => `
        <div class="screening-item skeleton-loading">
            <div class="skeleton-distance-badge"></div>
            <div class="skeleton-date"></div>
            <div class="skeleton-title"></div>
            <div class="skeleton-address"></div>
            <div class="skeleton-appointments">
                <div class="skeleton-appointment-label"></div>
                <div class="skeleton-time-slots">
                    <div class="skeleton-time-slot"></div>
                    <div class="skeleton-time-slot"></div>
                    <div class="skeleton-time-slot"></div>
                    <div class="skeleton-time-slot"></div>
                </div>
            </div>
        </div>
    `).join('');

    return skeletonItems;
}

// Helper function to determine package availability for a screening
function getPackageAvailability(screening) {
    if (!screening.state || !window.RESTRICTED_STATES) {
        return 'all'; // Default to all packages available
    }

    return window.RESTRICTED_STATES.includes(screening.state) ? 'limited' : 'all';
}

// Helper function to generate screening item HTML
function generateScreeningItemHTML(screening, index) {
    const date = screening.screeningDate ? screening.screeningDate.split("T")[0] : 'Date TBD';
    const appointmentCount = screening.appointments ? screening.appointments.length : 0;
    const packageAvailability = getPackageAvailability(screening);

    return `
        <div class="screening-item" data-screening-index="${index}" data-screening-id="${screening.screeningId || index}" tabindex="0" role="button" aria-label="View details for ${screening.siteName || 'Unknown Location'} screening on ${formatDate(date)}">
            <div class="screening-badges">
                <div class="screening-distance-badge">${screening.distanceAway !== null && screening.distanceAway !== undefined ? screening.distanceAway : 'N/A'} miles</div>
            </div>
            <div class="screening-date-text">${formatDate(date)}</div>
            <h3 class="screening-site-name">${screening.siteName || 'Unknown Location'}</h3>
            <p class="screening-address">${screening.address1 || ''} ${screening.address2 || ''}  ${screening.city || ''}, ${screening.state || ''} ${screening.zipCode || ''}</p>
            ${appointmentCount > 0 ? `
                <div class="appointment-times">
                    <strong>Select a time:</strong>
                    <div class="appointment-time-slots collapsed" data-screening-id="${screening.screeningId || index}">
                        ${screening.appointments.map(apt =>
                            `<button class="appointment-time-slot" type="button" role="button" aria-label="Select appointment time ${apt.appointmentTime ? formatTime(apt.appointmentTime) : 'Time TBD'}" tabindex="0">
                                ${apt.appointmentTime ? formatTime(apt.appointmentTime) : 'Time TBD'}
                            </button>`
                        ).join('')}
                    </div>
                    ${appointmentCount > 15 ? `
                        <button class="show-more-appointments" data-screening-id="${screening.screeningId || index}">
                            <span class="text">Show More</span>
                            <span class="arrow">▼</span>
                        </button>
                    ` : ''}
                </div>
            ` : ''}
        </div>
    `;
}

// Helper function to create load more button HTML
function createLoadMoreButtonHTML(remainingCount) {
    return `
        <div class="load-more-container">
            <button id="load-more-btn" class="load-more-btn">
                Load More (${remainingCount} remaining)
            </button>
        </div>
    `;
}
